<svg class="icon" [attr.viewbox]="viewbox" [ngClass]="['is--' + anchor]" [attr.aria-hidden]="ariaHidden" [attr.title]="title || anchor">
  <use [attr.xlink:href]="'/assets/dist/svg/symbol/svg/sprite.symbol.svg#' + anchor"></use>
</svg>
